import { render, staticRenderFns } from "./TotalesFactura.vue?vue&type=template&id=11cd83dc&scoped=true&"
import script from "./TotalesFactura.vue?vue&type=script&lang=js&"
export * from "./TotalesFactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cd83dc",
  null
  
)

export default component.exports